import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import PropTypes from "prop-types";
import {wizardGroupInterface} from "../../../../../interfaces/wizardItemInterface";
import LookWizardSectionFilterItem from "./lookWizardSectionFilterItem";
import {findParentWizardFeatureGroup, getFeatureGroupFromWizardGroup} from "./lookWizardFunctions";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";


const LookWizardSectionFilters = (props) => {

  const {wizardGroup, lookViewType, allFilterGroups, wizardActiveItem} = props;
  console.log("wizardGroup", wizardGroup);

  const filterGroup = allFilterGroups.find(group => group.name === wizardGroup.groupName);
  if (!filterGroup) {
    return null
  }

  const parentWizardGroup = findParentWizardFeatureGroup(wizardGroup, wizardActiveItem);
  if (!parentWizardGroup) {
    return null
  }

  const featureGroup = getFeatureGroupFromWizardGroup(parentWizardGroup);
  if (!featureGroup) {
    return null
  }

  console.log("featureGroup parent", featureGroup);

  let filterValues = filterGroup.values;
  if (Array.isArray(wizardGroup.filtersExcluded)) {
    filterValues = filterValues.filter(fValue => !wizardGroup.filtersExcluded.includes(fValue.id))
  }

  return (
    <Fragment>
      {IS_PRODUCT_JOURNEY ? (
        <div className="grohe-features__title">
          <span className="grohe-features__title-text bold">
            <FormattedMessage id="buttons.select"/> {filterGroup.name}
          </span>
        </div>
      ) : (
        <h3 className="lw-content__title">
          <FormattedMessage id="buttons.select"/> {filterGroup.name}
        </h3>
      )}
      <div className={"lm-features lm-features--type-" + lookViewType}>
        {filterValues.map(filterValue => {
          return <LookWizardSectionFilterItem featureGroup={featureGroup}
                                              filterGroup={filterGroup}
                                              filterValue={filterValue}
                                              wizardGroup={wizardGroup}
                                              key={filterValue.id}/>
        })}
      </div>
    </Fragment>
  )
};

LookWizardSectionFilters.propTypes = {
  wizardGroup: PropTypes.shape(wizardGroupInterface).isRequired,
}

const mapStateToProps = (store) => {
  const {lookViewType} = store.lookState;
  const {selectedFilters, filterGroups} = store.filterState;
  const {wizardActiveItem} = store.wizardState;

  return {
    fabricatorData: store.fabricatorState,
    lookViewType,
    selectedFilters,
    allFilterGroups: filterGroups,
    wizardActiveItem,
  };
};

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookWizardSectionFilters)
)
